import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/FormPrint/Get`, payload),
    Print: (payload) => Repository.post(`/api/FormPrint/Print`, payload),
}
